import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { UPDATE_FEATURE_KEY } from './keys';
import { updateReducer } from './reducers/update.reducer';
import { UpdateEffects } from './effects/update.effects';
import { UpdateDeviceBridge } from './bridges/update_device.bridge';

export function provideUpdateStore(): EnvironmentProviders[] {
    return [provideState(UPDATE_FEATURE_KEY, updateReducer), provideEffects(UpdateEffects, UpdateDeviceBridge)];
}
